/* eslint-disable import/prefer-default-export */

import { listUsers, createUser, deleteUser, sendActivation, updateUser } from './resources';

import {
  receivedGetUsersFail,
  receivedGetUsersSuccess,
  receivedAddUserFail,
  receivedAddUserSuccess,
  receivedDeleteUserFail,
  receivedDeleteUserSuccess,
  receivedUpdateUserFail,
  receivedUpdateUserSuccess,
  receivedSendActivationFail,
  receivedSendActivationSuccess,
  startLoading,
} from './actions';
import { receivedUpdatedProfileSuccess } from '../Authentication/actions';

/**
 * Get a list of users
 */
export const getUsers = () => (dispatch) => {
  dispatch(startLoading());

  return listUsers()
    .then((response) => {
      // @ts-expect-error TS(2339)
      dispatch(receivedGetUsersSuccess(response.results));
    })
    .catch((response) => {
      dispatch(receivedGetUsersFail(response.data));
    });
};

/**
 * Create a new user
 */
export const addUser = (email: string, role: string, actingAs: string | number) => (dispatch) => {
  dispatch(startLoading());

  return createUser(email, role, actingAs)
    .then((response) => {
      dispatch(receivedAddUserSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedAddUserFail(response.data));
    });
};

/**
 * Update an exisiting user
 */
export const changeUser = (userProfileId: number, role: number, actingAs: string | number) => (dispatch, getState) => {
  dispatch(startLoading());

  const currentUserProfile = getState().getIn(['auth', 'user', 'profile']);

  return updateUser(userProfileId, role, actingAs)
    .then((response) => {
      dispatch(receivedUpdateUserSuccess(response));
      if (currentUserProfile.id === userProfileId) {
        dispatch(receivedUpdatedProfileSuccess(response));
      }
    })
    .catch((response) => {
      dispatch(receivedUpdateUserFail(response.data));
    });
};

/**
 * Remove an exisiting user
 */
export const removeUser = (userId: number, actingAs: string | number) => (dispatch) => {
  dispatch(startLoading());

  return deleteUser(userId, actingAs)
    .then(() => {
      dispatch(receivedDeleteUserSuccess(userId));
    })
    .catch((response) => {
      dispatch(receivedDeleteUserFail(response.data));
    });
};

/**
 * Send activation an exisiting user
 */
export const resendActivation = (userId) => (dispatch) => {
  dispatch(startLoading());

  return sendActivation(userId)
    .then(() => {
      dispatch(receivedSendActivationSuccess());
    })
    .catch((response) => {
      dispatch(receivedSendActivationFail(response.data));
    });
};
